// extracted by mini-css-extract-plugin
module.exports = {"container":"rTNpe","tip_icon":"_1LdVr","tip_close":"_13mJm","title":"_1tpTK","banner":"_2BVlH","banner2":"_3-1xJ","banner3":"_1RU71"};